import React from 'react'
import './style.sass'
import { Link } from "react-router-dom"
import LazyLoad from 'react-lazy-load'
import { repareImage } from 'functions/repareDataService'
import { BASE_PORTAL, PORTAL_URL, LAZY_L, NO_IMAGE, IMAGE_THUMB, SIZE_IMAGE_THUMB } from 'constants/general'
import HistorialNav from 'components/HistorialNav'

export default function PromotionAnnouncement(props) {

    const {
        styleView,
        promotionAnnouncement,
        respHomeV3
    } = props

    return (
        promotionAnnouncement &&
        <div className={`container`} >
            {styleView === "a"
                ?
                <div className="promotionA1" >
                    {
                        promotionAnnouncement.map(({ link, image, id }, index) =>
                            index <= 2 && typeof (link) !== 'function'
                                ? link?.split('/')[1] === "c" || link?.indexOf('https://') >= 0 || link?.indexOf('http://') >= 0
                                    ? <a href={link} key={id} className={`link${index}`}>
                                        {LAZY_L
                                            ?
                                                <LazyLoad height={768} width={768} offset={100} threshold={0.95}>
                                                    <img
                                                        src={`${repareImage(image)}`}
                                                        alt={BASE_PORTAL + link + 1}
                                                        width="768"
                                                        height="768"
                                                        loading="lazy"
                                                        decoding="async"
                                                        fetchpriority="low"
                                                    />
                                                </LazyLoad>
                                            :
                                                <img
                                                    src={`${repareImage(image)}`}
                                                    alt={BASE_PORTAL + link + 1}
                                                    width="768"
                                                    height="768"
                                                    loading="lazy"
                                                    decoding="async"
                                                    fetchpriority="low"
                                                />
                                       }
                                    </a>
                                    :
                                    <Link to={PORTAL_URL + link} key={id} className={`link${index}`}>
                                        {LAZY_L
                                            ?
                                                <LazyLoad height={768} width={768} offset={100} threshold={0.95}>
                                                    <img
                                                        src={`${repareImage(image)}`}
                                                        alt={BASE_PORTAL + link + 2}
                                                        width="768"
                                                        height="768"
                                                        loading="lazy"
                                                        decoding="async"
                                                        fetchpriority="low"
                                                    />
                                                </LazyLoad>
                                            :
                                                <img
                                                    src={`${repareImage(image)}`}
                                                    alt={BASE_PORTAL + link + 2}
                                                    width="768"
                                                    height="768"
                                                    loading="lazy"
                                                    decoding="async"
                                                    fetchpriority="low"
                                                />
                                       }
                                    </Link>
                                : null
                        )
                    }
                </div>
                :
                styleView === "b"
                    ?
                    <div className="promotionA2" >
                        {
                            promotionAnnouncement.map(({ link, image, id }, index) =>
                                index <= 2 &&
                                    typeof (link) !== 'function'
                                    ? link?.split('/')[1] === "c" || link?.indexOf('https://') >= 0 || link?.indexOf('http://') >= 0
                                        ? <a href={link} key={id} className={`link${index}`}>
                                            {LAZY_L
                                                ?
                                                    <LazyLoad height={768} width={768} offset={100} threshold={0.95}>
                                                        <img
                                                            src={`${repareImage(image)}`}
                                                            alt={BASE_PORTAL + link + 1}
                                                            width="768"
                                                            height="768"
                                                            loading="lazy"
                                                            decoding="async"
                                                            fetchpriority="low"
                                                        />
                                                    </LazyLoad>
                                                :
                                                    <img
                                                        src={`${repareImage(image)}`}
                                                        alt={BASE_PORTAL + link + 1}
                                                        width="768"
                                                        height="768"
                                                        loading="lazy"
                                                        decoding="async"
                                                        fetchpriority="low"
                                                    />
                                        }
                                        </a>
                                        : <Link to={PORTAL_URL + link} key={id} className={`link${index}`}>
                                            {LAZY_L
                                                ?
                                                    <LazyLoad height={768} width={768} offset={100} threshold={0.95}>
                                                        <img
                                                            src={`${repareImage(image)}`}
                                                            alt={BASE_PORTAL + link + 2}
                                                            width="768"
                                                            height="768"
                                                            loading="lazy"
                                                            decoding="async"
                                                            fetchpriority="low"
                                                        />
                                                    </LazyLoad>
                                                :
                                                    <img
                                                        src={`${repareImage(image)}`}
                                                        alt={BASE_PORTAL + link + 2}
                                                        width="768"
                                                        height="768"
                                                        loading="lazy"
                                                        decoding="async"
                                                        fetchpriority="low"
                                                    />
                                            }
                                        </Link>
                                    : null
                            )
                        }
                    </div>
                    :
                    styleView === "c"
                        ?
                        <div className="promotionA3" >
                            {
                                promotionAnnouncement.map(({ link, image, id }, index) =>
                                    index <= 2 &&
                                        typeof (link) !== 'function'
                                        ? link?.split('/')[1] === "c" || link?.indexOf('https://') >= 0 || link?.indexOf('http://') >= 0
                                            ? <a href={link} key={id} className={`link${index}`}>
                                                {LAZY_L
                                                    ?
                                                        <LazyLoad height={768} width={768} offset={100} threshold={0.95}>
                                                            <img
                                                                src={`${repareImage(image)}`}
                                                                alt={BASE_PORTAL + link + 1}
                                                                width="768"
                                                                height="768"
                                                                loading="lazy"
                                                                decoding="async"
                                                                fetchpriority="low"
                                                            />
                                                        </LazyLoad>
                                                    :
                                                        <img
                                                            src={`${repareImage(image)}`}
                                                            alt={BASE_PORTAL + link + 1}
                                                            width="768"
                                                            height="768"
                                                            loading="lazy"
                                                            decoding="async"
                                                            fetchpriority="low"
                                                        />
                                                }
                                            </a>
                                            : <Link to={PORTAL_URL + link} key={id} className={`link${index}`}>
                                                {LAZY_L
                                                    ?
                                                        <LazyLoad height={768} width={768} offset={100} threshold={0.95}>
                                                            <img
                                                                src={`${repareImage(image)}`}
                                                                alt={BASE_PORTAL + link + 2}
                                                                width="768"
                                                                height="768"
                                                                loading="lazy"
                                                                decoding="async"
                                                                fetchpriority="low"
                                                            />
                                                        </LazyLoad>
                                                    :
                                                        <img
                                                            src={`${repareImage(image)}`}
                                                            alt={BASE_PORTAL + link + 2}
                                                            width="768"
                                                            height="768"
                                                            loading="lazy"
                                                            decoding="async"
                                                            fetchpriority="low"
                                                        />
                                                }
                                            </Link>
                                        : null
                                )
                            }
                        </div>
                        :
                        styleView === "d"
                            ?
                            <div className="promotionA4" >
                                {
                                    promotionAnnouncement.map(({ link, image, id }, index) =>
                                        index <= 1 &&
                                            typeof (link) !== 'function'
                                            ? link?.split('/')[1] === "c" || link?.indexOf('https://') >= 0 || link?.indexOf('http://') >= 0
                                                ? <a href={link} key={id} className={`link${index}`}>
                                                    {LAZY_L
                                                        ?
                                                            <LazyLoad height={768} width={768} offset={100} threshold={0.95}>
                                                                <img
                                                                    src={`${repareImage(image)}`}
                                                                    alt={BASE_PORTAL + link + 1}
                                                                    width="768"
                                                                    height="768"
                                                                    loading="lazy"
                                                                    decoding="async"
                                                                    fetchpriority="low"
                                                                />
                                                            </LazyLoad>
                                                        :
                                                            <img
                                                                src={`${repareImage(image)}`}
                                                                alt={BASE_PORTAL + link + 1}
                                                                width="768"
                                                                height="768"
                                                                loading="lazy"
                                                                decoding="async"
                                                                fetchpriority="low"
                                                            />
                                                    }
                                                </a>
                                                : <Link to={PORTAL_URL + link} key={id} className={`link${index}`}>
                                                    {LAZY_L
                                                        ?
                                                            <LazyLoad height={768} width={768} offset={100} threshold={0.95}>
                                                                <img
                                                                    src={`${repareImage(image)}`}
                                                                    alt={BASE_PORTAL + link + 2}
                                                                    width="768"
                                                                    height="768"
                                                                    loading="lazy"
                                                                    decoding="async"
                                                                    fetchpriority="low"
                                                                />
                                                            </LazyLoad>
                                                        :
                                                            <img
                                                                src={`${repareImage(image)}`}
                                                                alt={BASE_PORTAL + link + 2}
                                                                width="768"
                                                                height="768"
                                                                loading="lazy"
                                                                decoding="async"
                                                                fetchpriority="low"
                                                            />
                                                    }
                                                </Link>
                                            : null
                                    )
                                }
                            </div>
                            :
                            styleView === "e"
                                ?
                                <div className="promotionA5" >
                                    {
                                        promotionAnnouncement.map(({ link, image, id }, index) =>
                                            index <= 3 &&
                                                typeof (link) !== 'function'
                                                ? link?.split('/')[1] === "c" || link?.indexOf('https://') >= 0 || link?.indexOf('http://') >= 0
                                                    ? <a href={link} key={id} className={`link${index}`}>
                                                        {LAZY_L
                                                            ?
                                                                <LazyLoad height={768} width={768} offset={100} threshold={0.95}>
                                                                    <img
                                                                        src={`${repareImage(image)}`}
                                                                        alt={BASE_PORTAL + link + 1}
                                                                        width="768"
                                                                        height="768"
                                                                        loading="lazy"
                                                                        decoding="async"
                                                                        fetchpriority="low"
                                                                    />
                                                                </LazyLoad>
                                                            :
                                                                <img
                                                                    src={`${repareImage(image)}`}
                                                                    alt={BASE_PORTAL + link + 1}
                                                                    width="768"
                                                                    height="768"
                                                                    loading="lazy"
                                                                    decoding="async"
                                                                    fetchpriority="low"
                                                                />
                                                        }
                                                    </a>
                                                    : <Link to={PORTAL_URL + link} key={id} className={`link${index}`}>
                                                        {LAZY_L
                                                            ?
                                                                <LazyLoad height={768} width={768} offset={100} threshold={0.95}>
                                                                    <img
                                                                        src={`${repareImage(image)}`}
                                                                        alt={BASE_PORTAL + link + 2}
                                                                        width="768"
                                                                        height="768"
                                                                        loading="lazy"
                                                                        decoding="async"
                                                                        fetchpriority="low"
                                                                    />
                                                                </LazyLoad>
                                                            :
                                                                <img
                                                                    src={`${repareImage(image)}`}
                                                                    alt={BASE_PORTAL + link + 2}
                                                                    width="768"
                                                                    height="768"
                                                                    loading="lazy"
                                                                    decoding="async"
                                                                    fetchpriority="low"
                                                                />
                                                        }
                                                    </Link>
                                                : null
                                        )
                                    }
                                </div>
                                :
                                styleView === "f"
                                    ?
                                    <div className="promotionA6" >
                                    {
                                        promotionAnnouncement.map(({ link, image, id }, index) =>
                                            index <= 4 &&
                                                typeof (link) !== 'function'
                                                ? link?.split('/')[1] === "c" || link?.indexOf('https://') >= 0 || link?.indexOf('http://') >= 0
                                                    ? <a href={link} key={id} className={`link${index}`}>
                                                        {LAZY_L
                                                            ?
                                                                <LazyLoad height={768} width={768} offset={100} threshold={0.95}>
                                                                    <img
                                                                        src={`${repareImage(image)}`}
                                                                        alt={BASE_PORTAL + link + 1}
                                                                        width="768"
                                                                        height="768"
                                                                        loading="lazy"
                                                                        decoding="async"
                                                                        fetchpriority="low"
                                                                    />
                                                                </LazyLoad>
                                                            :
                                                                <img
                                                                    src={`${repareImage(image)}`}
                                                                    alt={BASE_PORTAL + link + 1}
                                                                    width="768"
                                                                    height="768"
                                                                    loading="lazy"
                                                                    decoding="async"
                                                                    fetchpriority="low"
                                                                />
                                                        }
                                                    </a>
                                                    : <Link to={PORTAL_URL + link} key={id} className={`link${index}`}>
                                                        {LAZY_L
                                                            ?
                                                                <LazyLoad height={768} width={768} offset={100} threshold={0.95}>
                                                                    <img
                                                                        src={`${repareImage(image)}`}
                                                                        alt={BASE_PORTAL + link + 2}
                                                                        width="768"
                                                                        height="768"
                                                                        loading="lazy"
                                                                        decoding="async"
                                                                        fetchpriority="low"
                                                                    />
                                                                </LazyLoad>
                                                            :
                                                                <img
                                                                    src={`${repareImage(image)}`}
                                                                    alt={BASE_PORTAL + link + 2}
                                                                    width="768"
                                                                    height="768"
                                                                    loading="lazy"
                                                                    decoding="async"
                                                                    fetchpriority="low"
                                                                />
                                                        }
                                                    </Link>
                                                : null
                                        )
                                    }
                                    </div>
                                    : styleView === "h"
                                        ? <div className='promotionHistorial'>
                                            <HistorialNav respHomeV3={respHomeV3} />
                                        </div>
                                        : <div className="promotionAD" >
                                                {
                                                    promotionAnnouncement.map(({ link, image, id }, index) =>
                                                        index === 0 &&
                                                            typeof (link) !== 'function'
                                                            ? link?.split('/')[1] === "c" || link?.indexOf('https://') >= 0 || link?.indexOf('http://') >= 0
                                                                ? <a href={link} key={id} className={`link${index}`}>
                                                                    {LAZY_L
                                                                        ?
                                                                            <LazyLoad height={768} width={768} offset={100} threshold={0.95}>
                                                                                <img
                                                                                    src={`${repareImage(image)}`}
                                                                                    alt={BASE_PORTAL + link + 1}
                                                                                    width="768"
                                                                                    height="768"
                                                                                    loading="lazy"
                                                                                    decoding="async"
                                                                                    fetchpriority="low"
                                                                                />
                                                                            </LazyLoad>
                                                                        :
                                                                            <img
                                                                                src={`${repareImage(image)}`}
                                                                                alt={BASE_PORTAL + link + 1}
                                                                                width="768"
                                                                                height="768"
                                                                                loading="lazy"
                                                                                decoding="async"
                                                                                fetchpriority="low"
                                                                            />
                                                                    }
                                                                </a>
                                                                : <Link to={PORTAL_URL + link} key={id} className={`link${index}`}>
                                                                    {LAZY_L
                                                                        ?
                                                                            <LazyLoad height={768} width={768} offset={100} threshold={0.95}>
                                                                                <img
                                                                                    src={`${repareImage(image)}`}
                                                                                    alt={BASE_PORTAL + link + 2}
                                                                                    width="768"
                                                                                    height="768"
                                                                                    loading="lazy"
                                                                                    decoding="async"
                                                                                    fetchpriority="low"
                                                                                />
                                                                            </LazyLoad>
                                                                        :
                                                                            <img
                                                                                src={`${repareImage(image)}`}
                                                                                alt={BASE_PORTAL + link + 2}
                                                                                width="768"
                                                                                height="768"
                                                                                loading="lazy"
                                                                                decoding="async"
                                                                                fetchpriority="low"
                                                                            />
                                                                    }
                                                                </Link>
                                                            : null
                                                    )
                                                }
                                            </div>

            }
        </div>
    )
}

//old
export function PromotionAnnouncementOld({ promotionAnnouncement }) {

    const { link, image } = promotionAnnouncement

    return (
        <div className="promotionAnnouncement">
            <div className="container">
                <a href={PORTAL_URL + link} title="Beneficios">
                    {LAZY_L
                        ?
                            <LazyLoad height={768} width={768} offset={100} threshold={0.95}>
                                <img
                                    src={`${repareImage(image)}`}
                                    alt={BASE_PORTAL + link + 2}
                                    width="768"
                                    height="768"
                                    loading="lazy"
                                    decoding="async"
                                    fetchpriority="low"
                                />
                            </LazyLoad>
                        :
                            <img
                                src={`${repareImage(image)}`}
                                alt={BASE_PORTAL + link + 2}
                                width="768"
                                height="768"
                                loading="lazy"
                                decoding="async"
                                fetchpriority="low"
                            />
                    }
                </a>
            </div>
        </div>
    )
}